import { useEffect } from 'react';

/**
 * Global scheduled browser notifications for Focus Critter.
 * - Morgon 07:30 — "Godmorgon! Din morgonrutin väntar"
 * - Kväll 21:00 — "Dags för kvällsrutinen"
 * - Varje heltimme 08:00–22:00 — "Dags att dricka vatten 💧"
 *
 * Respects per-notification-key localStorage throttle (once per hour/day)
 * so even if the user reloads the tab several times we don't spam.
 */
export default function RoutineNotifications() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('Notification' in window)) return;

    const tick = () => {
      if (Notification.permission !== 'granted') return;
      const now = new Date();
      const h = now.getHours();
      const m = now.getMinutes();
      const dateKey = now.toISOString().slice(0, 10); // YYYY-MM-DD
      const hourKey = `${dateKey}-${h}`;

      // 🌞 Morgonrutin — 07:30 (fires anytime 07:30–07:59)
      if (h === 7 && m >= 30) {
        const k = `notif_morning_${dateKey}`;
        if (!localStorage.getItem(k)) {
          try {
            new Notification('🌞 Godmorgon Sofia!', {
              body: 'Din morgonrutin väntar — 4 snabba saker och sen är du redo för dagen 🐾',
              tag: 'fc-morning',
              icon: '/favicon.ico',
            });
            localStorage.setItem(k, '1');
          } catch { /* ignore */ }
        }
      }

      // 🌙 Kvällsrutin — 21:00 (fires 21:00–21:59)
      if (h === 21) {
        const k = `notif_evening_${dateKey}`;
        if (!localStorage.getItem(k)) {
          try {
            new Notification('🌙 Dags för kvällsrutinen!', {
              body: '4 snabba saker och sen kan du mysa i soffan 🐾',
              tag: 'fc-evening',
              icon: '/favicon.ico',
            });
            localStorage.setItem(k, '1');
          } catch { /* ignore */ }
        }
      }

      // 💧 Vatten-påminnelse — varje heltimme 08:00–22:00 (fires 08:00–08:04, 09:00–09:04, etc.)
      if (h >= 8 && h <= 22 && m < 5) {
        const k = `notif_water_${hourKey}`;
        if (!localStorage.getItem(k)) {
          try {
            const messages = [
              'Dags att dricka vatten! 💧',
              'Glas #' + (h - 7) + ' — ditt husdjur påminner 💧',
              'En liten klunk vatten? 💧',
              'Vätska = hjärnbränsle 🧠💧',
              'Hydrera ADHD-hjärnan 💧🐾',
            ];
            new Notification('💧 Vattenpåminnelse', {
              body: messages[h % messages.length],
              tag: 'fc-water',
              icon: '/favicon.ico',
            });
            localStorage.setItem(k, '1');
          } catch { /* ignore */ }
        }
      }
    };

    // Run every 60s; also run immediately so reloading at 07:31 still triggers today
    tick();
    const interval = setInterval(tick, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return null;
}
